import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import './ToolActionResultDialog.css';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ToolActionResultDialog({
    isOpen,
    viewLogsHandler,
    submitHandler,
    toolActionResult
}) {
    useTranslationSubscription();
    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={`wrapDialog tool-action-result-popup`}
        >
            <DialogContent>
                <div className="popup-content">
                    <div className="popup-label">
                        {trI18n('COMPLETION')}
                    </div>

                    <ul className="popup-detail-list">
                        <li className="popup-detail-item">
                            <p className="item-label">{trI18n('SUCCESS_COUNT')}</p>
                            <p className="item-info success">{toolActionResult?.successCount || 0}</p>
                        </li>
                        <li className="popup-detail-item">
                            <p className="item-label">{trI18n('FAIL_COUNT')}</p>
                            <p className="item-info fail">{toolActionResult?.failCount || 0}</p>
                        </li>
                    </ul>

                    <div className="popup-btns">
                        <Button
                            className='popup-btn sub-primary'
                            onClick={viewLogsHandler}
                        >
                            {trI18n('VIEW_LOG_DETAIL')}
                        </Button>
                        <Button
                            className='popup-btn primary'
                            onClick={submitHandler}
                        >
                            {trI18n('SUBMIT')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
